module.exports = __webpack_public_path__ + "img/italy.2063c347.svg";